import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 14/17;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 17 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.5 10.646c-2.015 0-3.646-1.563-3.796-3.543L1.918 4.946c-.367.46-.704.947-.976 1.479a.862.862 0 000 .777c1.44 2.816 4.293 4.721 7.558 4.721.715 0 1.404-.106 2.069-.278L9.19 10.576a3.821 3.821 0 01-.691.07zm8.336 1.546l-2.937-2.274a8.813 8.813 0 002.158-2.716.862.862 0 000-.777c-1.44-2.816-4.292-4.722-7.557-4.722a8.173 8.173 0 00-3.913 1.004L1.207.09a.424.424 0 00-.596.075L.089.837a.426.426 0 00.075.598l15.628 12.102a.424.424 0 00.597-.075l.522-.673a.426.426 0 00-.075-.597zm-4.88-3.78l-1.044-.808a2.526 2.526 0 00-.856-2.832 2.513 2.513 0 00-2.228-.413c.16.218.246.48.247.751-.004.09-.018.18-.041.266L6.079 3.862a3.776 3.776 0 012.42-.881 3.82 3.82 0 012.706 1.122 3.834 3.834 0 011.12 2.71c0 .576-.14 1.112-.37 1.6z" fill={color} fillRule="nonzero"/>
    </svg>
)

export default class IconEyeStrike extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
